import React from 'react';
import { Link } from 'react-router-dom';
export function SmsTermsPage() {
  return <main className="pt-32 pb-24 bg-brand-black min-h-screen" data-id="element-435">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-436">
        <div className="mb-12 border-b border-brand-gold/20 pb-8" data-id="element-437">
          <h1 className="font-heading text-4xl md:text-5xl text-brand-white mb-4" data-id="element-438">
            SMS Terms & Consent
          </h1>
          <p className="text-brand-gold font-medium text-lg" data-id="element-439">
            Important information about opting in to receive text messages from
            Deluxe MedSpa Beauty.
          </p>
        </div>

        <div className="prose prose-invert prose-brand max-w-none text-brand-champagne-light/80 space-y-8" data-id="element-440">
          <p className="text-lg leading-relaxed" data-id="element-441">
            These SMS Terms explain the types of text messages you may receive
            from Deluxe MedSpa Beauty, how consent is collected, message
            frequency, fees, and how to get help or opt out.
          </p>

          <section data-id="element-442">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-443">
              1. Types of Messages
            </h2>
            <p className="mb-4" data-id="element-444">You may receive SMS messages related to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-445">
              <li data-id="element-446">appointment requests</li>
              <li data-id="element-447">consultation confirmations</li>
              <li data-id="element-448">appointment reminders</li>
              <li data-id="element-449">follow-up communications</li>
              <li data-id="element-450">service-related updates</li>
              <li data-id="element-451">promotional offers and specials, if you separately opt in</li>
            </ul>
          </section>

          <section data-id="element-452">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-453">
              2. Consent to Receive Messages
            </h2>
            <div className="bg-brand-charcoal border border-brand-charcoal p-6 rounded-sm" data-id="element-454">
              <p className="text-brand-white" data-id="element-455">
                Consent to receive SMS messages is collected through website
                forms where you voluntarily check an unchecked consent box.
                Consent is not a condition of purchase.
              </p>
            </div>
          </section>

          <section data-id="element-456">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-457">
              3. Message Frequency
            </h2>
            <p data-id="element-458">
              Message frequency may vary based on your interaction with Deluxe
              MedSpa Beauty.
            </p>
          </section>

          <section data-id="element-459">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-460">
              4. Message and Data Rates
            </h2>
            <p data-id="element-461">Message and data rates may apply.</p>
          </section>

          <section data-id="element-462">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-463">
              5. Opt-Out Instructions
            </h2>
            <p className="font-medium text-brand-white" data-id="element-464">
              Reply STOP at any time to unsubscribe from SMS messages.
            </p>
          </section>

          <section data-id="element-465">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-466">
              6. Help Instructions
            </h2>
            <p className="font-medium text-brand-white" data-id="element-467">
              Reply HELP for assistance.
            </p>
          </section>

          <section data-id="element-468">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-469">
              7. Contact Information
            </h2>
            <div className="bg-brand-charcoal/50 p-6 rounded-sm border border-brand-charcoal inline-block" data-id="element-470">
              <address className="not-italic text-brand-white" data-id="element-471">
                <strong className="text-brand-gold block mb-2 font-heading text-xl" data-id="element-472">
                  Deluxe MedSpa Beauty
                </strong>
                30 SW 1st St #1001
                <br data-id="element-473" />
                Miami, FL 33132
                <br data-id="element-474" />
                Phone: 786-901-0611
              </address>
            </div>
          </section>

          <section data-id="element-475">
            <h2 className="font-heading text-2xl text-brand-white mt-10 mb-4" data-id="element-476">
              8. Consent Records
            </h2>
            <p data-id="element-477">
              Deluxe MedSpa Beauty may retain records of opt-in consent where
              required for compliance and operational purposes.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-gold/20 flex flex-wrap gap-6" data-id="element-478">
          <Link to="/privacy-policy" className="text-brand-gold hover:text-brand-gold-light transition-colors" data-id="element-479">
            &larr; Read Privacy Policy
          </Link>
          <Link to="/terms-conditions" className="text-brand-gold hover:text-brand-gold-light transition-colors" data-id="element-480">
            Read Terms & Conditions &rarr;
          </Link>
        </div>
      </div>
    </main>;
}